import { Dispatch, SetStateAction } from 'react';

export const parseNumberInput = (value?: string) =>
  (value ?? '').replace(/[^.\d]/g, '').replace(/^(\d*\.?)|(\d*)\.?/g, '$1$2');

export const parsePositiveInput = (value?: string) =>
  (value ?? '').replace(/[^\d]/g, '');

export const handleNumberInputChange = (
  value?: string,
  setter?: Dispatch<SetStateAction<string>>
) => setter?.(parseNumberInput(value));

export const handlePositiveInputChange = (
  value?: string,
  setter?: Dispatch<SetStateAction<string>>
) => setter?.(parsePositiveInput(value));
